import CountryEnterprisePropertyModel from 'Models/directory/CountryEnterprisePropertyModel';
import EnterpriseModel                from 'Models/directory/EnterpriseModel';
import doc                            from 'decorators/doc';
import model                          from 'decorators/model';
import { Timestampable }              from 'helpers/traits';
import { Blamable }                   from 'helpers/traits';
import DirectoryPrivateApiModel       from 'modelx/models/abstracts/DirectoryPrivateApiModel';

@model.staticLabel('EnterpriseCountryEnterpriseProperty')
@model.urnResource('enterprise_country_enterprise_property')
@doc.path('/enterprise_country_enterprise_properties/{?id}')
export default class EnterpriseCountryEnterprisePropertyModel extends Blamable(Timestampable(DirectoryPrivateApiModel)) {
	public _filters: ModelFiltersExtended<{
		'countryEnterpriseProperty': id;
		'countryEnterpriseProperty.country': id;
		'countryEnterpriseProperty.enterpriseProperty': id;
		'countryEnterpriseProperty.enterpriseProperty.reference': DirectoryEnterprisePropertyReference;
		'enterprise': id;
		'enterprise.country': id;
		'id': id;
		'value': id;
	}> = {};

	public _sorts: ModelSortsExtended<unknown> = {};

	@doc.model(CountryEnterprisePropertyModel) declare countryEnterpriseProperty: CountryEnterprisePropertyModel;
	@doc.model(EnterpriseModel) declare enterprise: EnterpriseModel;
	@doc.string declare value: string;
}